import simg from '../images/service-single/1.jpg'
import simg2 from '../images/service-single/2.jpg'
import simg3 from '../images/service-single/3.jpg'
import simg4 from '../images/service-single/4.jpg'
import simg5 from '../images/service-single/5.jpg'
import simg6 from '../images/service-single/6.jpg'
import simg7 from '../images/service-single/7.jpg'
import simg8 from '../images/service-single/8.jpg'
import simg9 from '../images/service-single/9.jpg'
import simg10 from '../images/service-single/10.jpg'
import simg11 from '../images/service-single/11.jpg'
import simg12 from '../images/service-single/12.jpg'
import simg13 from '../images/service-single/13.jpg'

import sSingleimg1 from '../images/service-single/s1.jpg'
import sSingleimg2 from '../images/service-single/s2.jpg'


import ins1 from '../images/instragram/7.jpg'
import ins2 from '../images/instragram/8.jpg'
import ins3 from '../images/instragram/9.jpg'
import ins4 from '../images/instragram/10.jpg'
import ins5 from '../images/instragram/11.jpg'
import ins6 from '../images/instragram/12.jpg'


const Services = [
    {
        Id: '1',
        sImg:simg,
        sTitle: 'Function-First Design',
        description:'All our designs begin with purpose — layouts that prioritize natural light, circulation, storage, and comfort. We create spaces that serve how people live, heal, shop, or grow.',
        des2:'Function-first design approach prioritizing human needs.',
        des3:'Our design philosophy focuses on creating spaces that respond to human needs, not just form. Every façade, every floor plate, every interior must first serve the people who will use them.',
        icon:'fi flaticon-planning',
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
        sinst:ins1,
    },
    {
        Id: '2',
        sImg:simg2,
        sTitle: 'Smart-Ready Technology',
        description:'Technology is embedded from the beginning — from smart access and lighting to energy efficiency and integrated home systems. We build for the future, today.',
        des2:'Smart technology integration from concept to completion.',
        des3:'We embed smart technology throughout our developments, ensuring residents have access to the latest innovations in home automation, energy management, and connectivity.',
        icon:'fi flaticon-blueprint',
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
        sinst:ins2,
    },
    {
        Id: '3',
        sImg:simg3,
        sTitle: 'Community-Focused',
        description:'We don\'t just build apartments. We build micro-communities, complete with rooftop lounges, green courtyards, children\'s zones, and shared spaces.',
        des2:'Creating micro-communities with shared amenities and spaces.',
        des3:'Our developments focus on building communities, not just buildings. We create spaces where people can connect, relax, and grow together.',
        icon:'fi flaticon-double-bed',
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
        sinst:ins3,
    },
    {
        Id: '4',
        sImg:simg4,
        sTitle: 'Context-Aware Architecture',
        description:'Every site responds to its surroundings — whether it\'s the vibrant retail of AIZEL or the open skyline of Dubai South. We design for the environment.',
        des2:'Architecture that responds to and enhances its surroundings.',
        des3:'Our designs are context-aware, responding to the unique characteristics of each location while enhancing the surrounding environment.',
        icon:'fi flaticon-armchair',
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
        sinst:ins4,
    },
    {
        Id: '5',
        sImg:simg5,
        sTitle: 'Quality Over Quantity',
        description:'We focus on delivering fewer, better buildings —   each project is tightly curated with architectural oversight, premium materials, and refined finishes.',
        des2:'Curated quality over mass production in every project.',
        des3:'We believe in quality over quantity, ensuring each project receives the attention it deserves with the premium materials and expert craftsmanship.',
        icon:'fi flaticon-furniture',
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
        sinst:ins5,
    },
    {
        Id: '6',
        sImg:simg6,
        sTitle: 'Sustainable Development',
        description:'At MAAKDREAM, sustainability is not a feature — it\'s a responsibility. We create buildings that breathe with the environment instead of resisting it.',
        des2:'Climate-responsive architecture for a sustainable future.',
        des3:'Our sustainable approach includes climate-responsive design, natural airflow strategies, and locally sourced materials to minimize environmental impact.',
        icon:'fi flaticon-interior-design',
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
        sinst:ins6,
    },
    {
        Id: '7',
        sImg:simg7,
        sTitle: 'Turnkey Delivery',
        description:'From design to delivery, every step is fully integrated. We provide comprehensive project management ensuring timely delivery and quality control.',
        des2:'End-to-end project delivery from concept to completion.',
        des3:'Our turnkey approach means we handle every aspect of development, from initial planning to final handover, ensuring seamless project execution.',
        icon:'fi flaticon-planning',
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
        sinst:ins1,
    },
    {
        Id: '8',
        sImg:simg8,
        sTitle: 'Engineering Excellence',
        description:'With over 70 years of experience in delivering national megaprojects, we bring engineering depth to real estate design and development.',
        des2:'Seven decades of engineering expertise in construction and infrastructure.',
        des3:'Our engineering heritage spans roads, bridges, embassies, tunnels, flyovers, and commercial towers, providing a solid foundation for innovative real estate development.',
        icon:'fi flaticon-blueprint',
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
        sinst:ins2,
    },
    {
        Id: '9',
        sImg:simg9,
        sTitle: 'Architectural Innovation',
        description:'In collaboration with Marcus of ARCHI-TEX, we bring over 28 years of global architectural experience and award-winning design to every project.',
        des2:'Global architectural expertise with award-winning designs.',
        des3:'Our partnership with ARCHI-TEX brings international design standards and innovative architectural solutions to create distinctive and timeless developments.',
        icon:'fi flaticon-double-bed',
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
        sinst:ins3,
    },
    {
        Id: '10',
        sImg:simg10,
        sTitle: 'Infrastructure Development',
        description:'From highways and housing to high-rise towers and diplomatic facilities, we have delivered projects that define landscapes across Pakistan and now Dubai.',
        des2:'Comprehensive infrastructure development expertise.',
        des3:'Our infrastructure portfolio includes some of Pakistan\'s most significant projects, from signal-free corridors to embassy headquarters, demonstrating our capability in complex developments.',
        icon:'fi flaticon-armchair',
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
        sinst:ins4,
    },
    {
        Id: '11',
        sImg:simg11,
        sTitle: 'Project Management',
        description:'Our execution is driven by time-tested workflows, in-house machinery, and project discipline that ensures timely handovers even on high-pressure sites.',
        des2:'Proven project management with time-tested workflows.',
        des3:'We employ disciplined project management approaches that have been refined over seven decades, ensuring projects are delivered on time and within budget.',
        icon:'fi flaticon-furniture',
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
        sinst:ins5,
    },
    {
        Id: '12',
        sImg:simg12,
        sTitle: 'Investment Solutions',
        description:'We help investors capitalize on Dubai\'s real estate market with high rental yields, zero property taxes, and world-class infrastructure for optimal returns.',
        des2:'Strategic investment solutions in Dubai\'s dynamic real estate market.',
        des3:'Our developments offer investors access to Dubai\'s attractive real estate market with high rental yields, tax benefits, and world-class infrastructure.',
        icon:'fi flaticon-interior-design',
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
        sinst:ins6,
    }
];

export default Services;